module.exports = __webpack_public_path__ + "static/img/ic_favorite_sale_off@2x.24e730e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_favorite_sale_off@2x.png
// module id = ssXr
// module chunks = 1